import { SubscriptionEntry } from 'store/api/apiTypes';

export interface SubscriptionActionsCellProps {
  license: SubscriptionEntry;
  allSubscriptions?: SubscriptionEntry[];
  onNavigateToWebsites: () => void;
}

export const BASE_PLAN = 'core';
export const ADD_ON_PLAN = 'add-on';

export const planOf = (entry: SubscriptionEntry): string =>
  (entry.license.plan ?? '').trim().toLowerCase();
